// extracted by mini-css-extract-plugin
module.exports = {"FormatModal":"FormatModal_FormatModal__19wsQ","Title":"FormatModal_Title__1b6qA","Content":"FormatModal_Content__ZMTvU"};